import React, { Component } from "react";
import { encryptData } from "./utils/encryptionUtils";

export class LSC_Refeed extends Component {
    static displayName = LSC_Refeed.name;

    constructor(props) {
        super(props);
        this.state = {
            TbSrLineRunid: "",
            responseMessage: ""
        };
    }

    handleChange = (e) => {
        this.setState({ TbSrLineRunid: e.target.value });
    };

    callApi = async () => {
        const { TbSrLineRunid } = this.state;

        if (!TbSrLineRunid) {
            this.setState({ responseMessage: "Please input TbSrLineRunid" });
            return;
        }

        document.body.classList.add("wait-cursor");

        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            TbSrLineRunid: Number(TbSrLineRunid),
            RefLang: "en",
            Timestamp: timestamp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                Data: encryptedPayload,
                Timestamp: timestamp
            })
        };

        try {
            const response = await fetch("/api/ZPartnerLSCRefeed", requestOptions);
            const data = await response.json();

            if (data) {
                this.setState({
                    responseMessage: data.responseCode || "No responseCode"
                });
            } else {
                this.setState({ responseMessage: "No data!!" });
            }
        } catch (error) {
            console.error("API call error:", error);
            this.setState({ responseMessage: "API call error" });
        } finally {
            document.body.classList.remove("wait-cursor");
        }
    };

    render() {
        const { TbSrLineRunid, responseMessage } = this.state;

        return (
            <div>
                <input
                    type="text"
                    name="TbSrLineRunid"
                    value={TbSrLineRunid}
                    onChange={this.handleChange}
                />

                <button type="button" onClick={this.callApi}>
                    Call API - LSC Refeed
                </button>

                <div>{responseMessage}</div>
            </div>
        );
    }
}